import { render, staticRenderFns } from "./FormAuthorizationCustomer.vue?vue&type=template&id=79226f28"
import script from "./FormAuthorizationCustomer.vue?vue&type=script&lang=js"
export * from "./FormAuthorizationCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports